<template>
    <div class="user_core">
        <Header :title="title"></Header>
        <van-row class="info_body">
            <van-col span="24" class="info_s">
                <qrcode-vue :value="value" :size="size" level="H" />

                <van-row class="mynnid">
                    <van-col span="24">{{ $t('share.nanoid') }}：{{ nanoid }}</van-col>
                </van-row>
                <van-row>
                    <van-col span="24" class="pfriend">
                        {{ $t('share.myfriend') }}
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="24">
                        <van-list
                                v-model="loading"
                                :finished="finished"
                                :finished-text="$t('financial.noMore')"
                                @load="onLoad"
                        >
                            <van-cell v-for="(item,index) in list" :key="index" class="list_item">
                                <van-row >
                                    <van-col span="24" class="list_t">
                                        <van-row class="first">
                                            <van-col span="12" class="col1"><van-icon name="friends" color="red"/> {{item.name}}</van-col>
                                            <van-col span="12" class="col2">{{item.Hierarchy|hierarchy}}</van-col>
                                        </van-row>
                                        <van-row  class="sec">
                                            <van-col span="24" class="col3">{{item.create_time}}</van-col>
                                        </van-row>
                                    </van-col>
                                </van-row>
                            </van-cell>
                        </van-list>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import QrcodeVue from 'qrcode.vue'
  //  import { nanoid } from 'nanoid'

    export default {
        name: "Share",
        data(){
            return{
                title:this.$t('share.pagetitle'),
                value: 'http://'+window.location.host+"/Reg&pid ="+this.nanoid,
                size: 280,
                nanoid: '',
                list: [],
                loading: false,
                finished: false,
                page:0,
                page_size : 10
            }
        },
        mounted(){
            this.nanoid = this.$store.state.user.nanoid
        },
        filters:{
            hierarchy:function (value) {
                return this?.$t('share.myfriend',{value:value});
            }
        },
        methods:{

            onLoad() {

                this.getReq('/getfriend').then((res)=>{

                    if(res.code==200){

                        this.list= this.list.concat(res.data);
                        this.finished = true;
                    }
                });

                // 数据全部加载完成

            },

        },
        components:{
            Header,
            Footer,
            QrcodeVue
        }
    }
</script>

<style scoped lang="scss">
    .user_core{
        min-height: 650px;
        background: url("~@/assets/images/bg_header.png") no-repeat center 45px;
        background-size: 100% ;
        .info_body{
            width: 92%;
            min-height: 500px ;
            margin: 20px auto 0 auto;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
            .info_s {
                margin: 25px auto 40px auto;
                .mynnid{
                    margin: 15px auto;
                }
                .pfriend{
                    height: 35px;
                    width: 100%;
                    font-size: 16px;
                    line-height: 35px;
                    text-align: left;
                    text-indent: 15px;
                    color: #333;
                    font-weight: bold;
                    background: url("~@/assets/images/bg_group_suggest.png") no-repeat;
                    background-size: 100% 100%;
                }
                .list_item{
                    height: 80px;
                    line-height: 25px;
                    .list_t{
                        margin: 5px;
                        .first{
                            margin: 0 auto 5px auto;
                            .col1{

                            }
                            .col2{
                                text-align: right;
                                padding-right: 10px;
                            }
                        }
                        .sec{
                            .col3{
                                color: #ccc;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
